// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e2a459ad","453":"2f07b52b","455":"a92c1e24","977":"db4f2551"}[chunkId] + ".chunk.js";
};